// extracted by mini-css-extract-plugin
export var button = "_lt-2";
export var card = "_lt-0";
export var closeButtonContainer = "_lt-3";
export var iconContainer = "_lt-1";